import { ColumnsType } from 'antd/es/table'
import { SortOrder } from 'antd/es/table/interface'
import { Sorter } from 'components/Sorter/Sorter'
import { Status, STATUS_TYPES_CLASSNAMES } from 'components/Status'
import { IRfpHealthSystemWithHospitals } from './types'
import { Link } from '../../../../components/Link'
import { routes } from '../../../../router'

export const columns = ({
  showAmountOfHospitals,
  canSeeHealthSystem
}: {
  showAmountOfHospitals: boolean
  canSeeHealthSystem: boolean
}): ColumnsType<IRfpHealthSystemWithHospitals> => {
  const _columns: ColumnsType<IRfpHealthSystemWithHospitals> = [
    {
      dataIndex: 'name',
      key: 'name',
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<IRfpHealthSystemWithHospitals>
          dataIndex="name"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          {canSeeHealthSystem ? 'Health system' : 'Hospital'}
        </Sorter>
      ),
      render: (_, { name, uuid, hospital_level, children }) => (
        <>
          {hospital_level ? (
            <span className="name-column">{name}</span>
          ) : (
            <Link
              to={`${routes.myCommunity}${routes.healthSystem}/${uuid}`}
              className="name-column"
            >
              {name}
            </Link>
          )}
          {!hospital_level && showAmountOfHospitals && (
            <Status.Default className={STATUS_TYPES_CLASSNAMES.GRAY}>
              {`${children.length} Hospital${children.length === 1 ? '' : 's'}`}
            </Status.Default>
          )}
        </>
      ),
      sorter: true,
      showSorterTooltip: false
    }
  ]
  return _columns
}
